import { useEffect, useState } from 'react'
import { Network } from 'junco/src/network'

import { NetworkControls, NetworkOptions } from "./components/Network";
import { Training } from "./components/Training"
import { NetworkView } from "./components/NetworkView"
import { loadDataset } from './util/helpers';

import './index.css'

function App() {
  // default network structure
  const [netStructure, setNetStructure] = useState([5, 5, 2])

  // create network
  const n = new Network(netStructure, 81)
  const [network, setNetwork] = useState(n)

  const defaults = Array(network.nInputs).fill(0)
  const [inputs, setInputs] = useState(defaults)

  const [networkOutput, setNetworkOutput] = useState(network.evaluate(inputs))

  const [expectedOutputs, setExpectedOutputs] = useState(Array(network.nOutputs).fill(0))

  const [loss, setLoss] = useState(null)
  
  const [dataset, setDataset] = useState(null)

  const [trainingProgress, setTrainingProgress] = useState(null)

  // options
  const [options, setOptions] = useState({
    training: true
  })

  // replace network when update pressed with new strucutre
  useEffect(() => {
    const newNetwork = new Network(netStructure)

    console.log(netStructure)
    // set new default inputs
    var n = newNetwork.nInputs
    const d = Array(Number(n)).fill(0)
    setInputs(d)
  
    console.log('here')
    setNetwork(newNetwork)
    setNetworkOutput(newNetwork.evaluate(d))
  }, [netStructure])

  useEffect(() => {
    loadDataset(trainingSets[0].path, json => setDataset(json))
  }, [])

  const trainingSets = [
    {
      "name": "Iris",
      "path": "iris/irisNormalized.json",
      "description": 'A small classic dataset from Fisher, 1936. One of the earliest known datasets used for evaluating classification methods'
    },
    {
      "name": "Banknote",
      "path": "banknote/banknote.json",
      "description": 'Data were extracted from images that were taken for the evaluation of an authentication procedure for banknotes'
    }
  ]

  if(dataset) {
    var networkView = <NetworkView
    inputs={inputs}
    network={network}
    dataset={dataset}
    networkOutput={networkOutput}>
  </NetworkView>
  }
  else {
    var networkView = <p>Loading...</p>
  }

  return (
    <div className="App">
      <div className='AppWrapper'>
        <div className='header'>
          <h1 style={{'marginLeft': '3vh'}}>Neural Network</h1>
        </div>
        <div className='mainContent'>
          <div className='sidePanel'>
            <Training
              network={network}
              setNetwork={setNetwork}
              expectedOutputs={expectedOutputs}
              setExpectedOutputs={setExpectedOutputs}
              dataset={dataset}
              setDataset={setDataset}
              netStructure={netStructure}
              setNetStructure={setNetStructure}
              loss={loss}
              trainingSets={trainingSets}
              setTrainingProgress={setTrainingProgress}
              trainingProgress={trainingProgress}
            ></Training>
            <NetworkControls 
              network={network}
              setNetworkOutput={setNetworkOutput}
              setNetwork={setNetwork}
              netStructure={netStructure}
              setNetStructure={setNetStructure}
              inputs={inputs}
              setInputs={setInputs}
              setLoss={setLoss}
              expectedOutputs={expectedOutputs}
              dataset={dataset}
            ></NetworkControls>
          </div>
          <div className='networkView'>
            {networkView}
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
